if (!customElements.get('koeed-product-contact')) {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.koeed-purchase a[data-koeed-policy]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target?.tagName === 'DETAILS') target.open = true;
  });
  customElements.define('koeed-product-contact', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.refresh = () => {
        const input = this.productInfo?.querySelector('input[name="quantity"]');
        const quantity = input?.value || this.dataset.initialQuantity;
        const message = this.dataset.message + '\n' +
          this.dataset.quantityLabel + ': ' + quantity + '\n' +
          this.dataset.linkLabel + ': ' + this.dataset.productUrl;
        const email = this.querySelector('[data-koeed-email]');
        const whatsapp = this.querySelector('[data-koeed-whatsapp]');
        if (email) {
          const url = new URL(email.getAttribute('href'));
          url.searchParams.set('body', message);
          email.setAttribute('href', url.href);
        }
        if (whatsapp) {
          const url = new URL(whatsapp.getAttribute('href'));
          url.searchParams.set('text', message);
          whatsapp.setAttribute('href', url.href);
        }
      };
      this.productInfo?.addEventListener('input', this.refresh);
      this.productInfo?.addEventListener('change', this.refresh);
      this.addEventListener('click', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('input', this.refresh);
      this.productInfo?.removeEventListener('change', this.refresh);
      this.removeEventListener('click', this.refresh);
    }
  });
}
